import React from "react";
import { useTranslation } from "react-i18next";
import { AnimatePresence, motion } from "framer-motion";

import {
  EditionButton,
  EditionContainer,
  EditionLayer,
  RightSlideAnimation
} from "../../AdAssistant.styled";

const EditHoverLayer = ({
  isAdPreviewHovered,
  toggleEditionModal,
  width = "inherit",
  height = "inherit"
}) => {
  const { t } = useTranslation();

  return (
    <AnimatePresence>
      {isAdPreviewHovered && (
        <motion.div {...RightSlideAnimation} style={{ width, height, position: "absolute" }}>
          <EditionLayer>
            <EditionContainer>
              <EditionButton onClick={() => toggleEditionModal({ type: "text" })}>
                {t("Edit text")}
              </EditionButton>
              <EditionButton onClick={() => toggleEditionModal({ type: "image" })}>
                {t("Edit image")}
              </EditionButton>
            </EditionContainer>
          </EditionLayer>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default EditHoverLayer;
